import axios from "@/api/config_php";

export const billList = param =>
  axios.get(`/amp/api/v1/invoices/lists`, { params: param });
export const billCreate = param =>
  axios.post(`/amp/api/v1/invoices/store`, param);
export const billDetail = param =>
  axios.get(`/amp/api/v1/invoices/detail`, { params: param });
export const searchInvoiceCompany = param =>
  axios.get(`/amp/api/v1/invoices/searchInvoiceCompany`, { params: param });
export const getInvoiceCompany = param =>
  axios.post(`/amp/api/v1/invoices/getInvoiceCompany`, param);
export const billCancel = param =>
  axios.post(`/amp/api/v1/invoices/cancel`, param);
export const storeBill = param =>
  axios.post(`/amp/api/v1/invoices/store`, param);
export const editBill = param =>
  axios.post(`/amp/api/v1/invoices/edit`, param);
export const completeBill = param =>
  axios.post(`/amp/api/v1/invoices/complete`, param);

export const statementsList = param =>
  axios.get(`/amp/api/v1/clientBills/lists`, { params: param });
export const statementDetail = param =>
  axios.get(`/amp/api/v1/clientBills/detail`, { params: param });
export const statementAccountDetail = param =>
  axios.get(`/amp/api/v1/clientBills/accountDetail`, { params: param });
export const generateClientBills = param =>
  axios.get(`/amp/api/v1/clientBills/generateClientBills`, { params: param });

export const generateEipBills = param =>
  axios.get(`/amp/api/v1/eipBills/exportEipBills`, { params: param });

export const cancelInvoices = param =>
  axios.post(`/amp/api/v1/invoices/cancel`, param);
export const getUsdInvocieBills = param =>
  axios.get(`/amp/api/v1/invoices/getUsdInvocieBills`, { params: param });